import type { DataFormFieldOption } from 'components/data-form/attributes'
import { TickerOption } from '@/modules/asset/views/add-asset/components/ticker-option'
import { EAssetType, getRefId, type ICommodityQuote, type ISavedDocument } from 'findef'

export const commodityQuoteToOption = (
  commodity:
    | ISavedDocument<ICommodityQuote>
    | ISavedDocument<ICommodityQuote, string>
    | ICommodityQuote
): DataFormFieldOption => {
  const label = commodity.name || commodity.symbol || '?'
  return {
    label: label,
    key: getRefId(commodity),
    value: commodity,
    body: (props) => {
      return (
        <TickerOption
          assetType={EAssetType.COMMODITY}
          name={commodity.name}
          symbol={commodity.manuallyAdded ? 'No Symbol' : commodity.symbol}
          image={undefined}
          isOpen={props.isOpen}
          badge={'Commodity'}
          noImage={true}
        />
      )
    }
  }
}
